import React, { useCallback, useConp, useEffect, useState } from "react";
import SuccessModal from "../SuccessModal";
import { useLocation, useNavigate } from "react-router-dom";
import {
  deliveryOrder,
  refundOrder,
} from "../../services/OrderDelivery/deliveryOrder";
import {
  getCustomerSingleOrder,
  getCustomerSingleOrderInfo,
} from "../../services/OrdersAPI/Orders";
import { getDeliveryQrCode } from "../../services/QrCode/getDeliveryQrCode";
import { getStoreCustomerAccount } from "../../services/StoreCustomerAccount/getStoreCustomerAccount";
import { getLocalPaymentMode, getUserData } from "../../utils/localStorage";
import { subscriberOffer } from "../../services/subscriberOffer/SubscriberOffer";
import PaymentCollectionOrderInfoCard from "./PaymentCollectionOrderInfoCard";
import GarmentInfoQrCodeCard from "./GarmentInfoQrCodeCard";
import PaymentDetails from "./PaymentDetails";
import { Button } from "primereact/button";
import AuthCodeCustomerVerifyModal from "./AuthCodeCustomerVerifyModal";
import StoreMenu from "../StoreMenu";
import PaymentGatewayLinkCreateModal from "./PaymentGatewayLinkCreateModal";
import {
  setOrderPackageSubscription,
  setPackageSubscriptionOfferDefault,
} from "../../services/PaymentOfferManagement/CheckPackageSubscriptionOffer";
import ButtonLink from "../../ButtonLink";
import { storeCustomerGetInfo } from "../../services/CustomerInfo/CustomerInfo";
import { getOrderSubscriptionInfo } from "../../services/LoyaltyPoint/LoyaltyPoint";
import { ProgressSpinner } from "primereact/progressspinner";

const { innerWidth: width, innerHeight: height } = window;

const CardDataAfterProcessOrder = [
  {
    id: 1,
    name: "Back To Order",
    fillColor: "#E7F4FF", // You can set the desired colors
    borderColor: "#3EB3E1", // You can set the desired colors
    img: "Laundy_App_Icons_Gifs/Other_Icons/Back_to_Order.png", // Provide the correct image path
  },
  {
    id: 2,
    name: "Back To Profile",
    fillColor: "#FFF9DE",
    borderColor: "#F5C43A",
    img: "Laundy_App_Icons_Gifs/Other_Icons/Back_to_Profile.png",
  },
];

const PaymentCollection = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { storeCustomerId, bookingOrderId } = location.state || {}; // Fallback to prevent undefined errors

  const { brandProfileData, storeData, userProfileData } = getUserData();
  let storeId = storeData.id;
  let brandId = brandProfileData.id;

  const storeUserId = userProfileData.id;
  let scaccountHandleEnabled = storeData.scaccountHandleEnabled;
  let deliveryDiscount = storeData.enableDeliveryDiscount;
  let enableUserAccountDeliveryDiscount =
    storeData.enableUserAccountDeliveryDiscount;
  let enabledCreatePaymentLink = storeData.enabledCreatePaymentLink;
  let enabledSubscriptionDiscountOnDelivery =
    storeData.enabledSubscriptionDiscountOnDelivery;
  let enabledLoyaltyPointBrand = brandProfileData.enabledLoyaltyPoint;
  let enabledLoyaltyPointStore = storeData.enabledLoyaltyPoint;
  const enabledApplySubscriptionWithPackage =
    storeData.enabledApplySubscriptionWithPackage;
  const enabledAutoApplySubscriptionWithPackage =
    storeData.enabledAutoApplySubscriptionWithPackage;
  const enabledUPIAccount = storeData.enabledUPIAccount;
  let upiAccountId = storeData.upiAccountId;
  let upiAccountLink = storeData.upiAccountLink;
  let upiAccountName = storeData.upiAccountName;
  let enabledQRDeviceModal = storeData.enabledQRDeviceModal;
  const enabledAmountRoundOff = storeData.enabledAmountRoundOff ? 0 : 2;

  const [modalVisible, setModalVisible] = useState(false);
  const [apiResStatus, setApiResStatus] = useState(false);
  const [apiResMessage, setApiResMessage] = useState(false);

  const [customerOrdersData, setCustomerOrdersData] = useState({});
  const [paymentModeData, setPaymentModeData] = useState([]);
  const [readyToDeliveryData, setReadyToDeliveryData] = useState([]);
  const [storeCustomerAccountResponse, setStoreCustomerAccountResponse] =
    useState({});
  const [
    userAccountBalanceAmountDeliveryError,
    setUserAccountBalanceAmountDeliveryError,
  ] = useState("");

  const [
    paymentGatewayLinkCreateModalVisible,
    setPaymentGatewayLinkCreateModalVisible,
  ] = useState(false);

  const [visible, setVisible] = useState(false);

  const [modalMenuVisible, setModalMenuVisible] = useState(false);
  const [paymentMethodData, setPaymentMethodData] = useState("");
  const [paymentMethodSecondData, setPaymentMethodSecondData] = useState("");
  const [discountAmountData, setDiscountAmountData] = useState("");
  const [addDiscountData, setAddDiscountData] = useState("");
  const [receiveAmountValueData, setReceiveAmountValueData] = useState("");
  const [receiveAmountValueSecondData, setReceiveAmountValueSecondData] =
    useState("");
  const [otherRemarkValueData, setOtherRemarkValueData] = useState("");
  const [paymentErrorCheck, setPaymentErrorCheck] = useState("");
  const [availablePaymentBalance, setAvailablePaymentBalance] = useState(false);
  const [isReceivePaymentButtonPressed, setIsReceivePaymentButtonPressed] =
    useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [paymentMethodRefundData, setPaymentMethodRefundData] = useState(false);
  const [isCheckedRefundAmountCashData, setIsCheckedRefundAmountCashData] =
    useState(false);
  const [
    isCheckedRefundAmountUserAccountData,
    setIsCheckedRefundAmountUserAccountData,
  ] = useState(false);
  const [
    authCodeCustomerVerifyModalVisible,
    setAuthCodeCustomerVerifyModalVisible,
  ] = useState(false);
  const [orderSubscriptionInfo, setOrderSubscriptionInfo] = useState({});
  const [qrDeviceModalPayment, setQrDeviceModalPayment] = useState({});
  const [
    unprocessedGarmentWithSubscription,
    setUnprocessedGarmentWithSubscription,
  ] = useState(false);
  const [loading, setLoading] = useState(false);

  const [storeCustomerData, setStoreCustomerData] = useState([]);

  const orderInfoDetails = {
    orderNo: customerOrdersData?.orderNo ? customerOrdersData?.orderNo : "N/A",
    balanceAmount: customerOrdersData?.balanceAmount
      ? customerOrdersData?.balanceAmount
      : 0,
  };

  const orderPackageData = customerOrdersData?.orderPackage;

  const fetchGetCustomerSingleOrder = () => {
    setLoading(true);
    getCustomerSingleOrderInfo(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const customerOrdersDataRes = response.data;
          setCustomerOrdersData(customerOrdersDataRes);
          const UnprocessedGarment = response.data?.orderItem?.filter(
            (item) =>
              item.status === "IN_PROCESS" ||
              item.status === "IN_WAREHOUSE" ||
              item.status === "BOOKED",
          );
          if (
            UnprocessedGarment.length > 0 &&
            customerOrdersDataRes?.subscriptionDiscount > 0
          ) {
            setUnprocessedGarmentWithSubscription(true);
          } else {
            setUnprocessedGarmentWithSubscription(false);
          }
          setLoading(false);

          if (scaccountHandleEnabled === true) {
            // const fetchStoreCustomerAccount = () => {
            getStoreCustomerAccount(storeCustomerId, storeId)
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;
                  if (
                    customerOrdersDataRes.subscriptionDiscount === 0 ||
                    customerOrdersDataRes.subscriptionDiscount === null
                  ) {
                    Res.advanceUnit = Number(
                      Number(Res.advanceUnit - Res.subscriptionUnit)?.toFixed(
                        enabledAmountRoundOff,
                      ),
                    );
                  }
                  setStoreCustomerAccountResponse(Res);
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });

            if (customerOrdersDataRes?.subscriptionDiscount > 0) {
              getOrderSubscriptionInfo(storeId, storeCustomerId, bookingOrderId)
                .then((response) => {
                  if (!response.data.error) {
                    const customerOrdersDataRes = response.data;
                    setOrderSubscriptionInfo(customerOrdersDataRes);
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            }
            // };
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchGetDeliveryQrCode = () => {
    getDeliveryQrCode(storeCustomerId, storeId, bookingOrderId)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          // Filter items with status equal to 'READY_TO_DELIVER_BY_STORE'
          const readyToDelivery = Res.filter(
            (item) => item.status === "READY_TO_DELIVER_BY_STORE",
          );
          setReadyToDeliveryData(readyToDelivery);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const fetchLocalPaymentMode = async () => {
    const { paymentMode } = getLocalPaymentMode();
    if (paymentMode && Object.keys(paymentMode).length > 0) {
      let filteredModes = [...paymentMode?.paymentModeList?.Location1];

      // Remove ICICI_PG only if QR device modal is enabled
      if (enabledQRDeviceModal) {
        filteredModes = filteredModes.filter((item) => item !== "ICICI_PG");
      }

      // Remove ONLINE if payment link creation is disabled
      if (!enabledCreatePaymentLink) {
        filteredModes = filteredModes.filter((item) => item !== "ONLINE");
      }

      setPaymentModeData(filteredModes);
    } else {
      setPaymentModeData([]);
    }
  };

  const fetchStoreCustomerInfo = async () => {
    try {
      const response = await storeCustomerGetInfo(storeCustomerId, storeId);
      if (!response.data.error) {
        const Res = response.data;
        setStoreCustomerData(Res);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchGetDeliveryQrCode();
    fetchGetCustomerSingleOrder();
    fetchLocalPaymentMode();
    fetchStoreCustomerInfo();
    // if (scaccountHandleEnabled === true) {
    //   fetchStoreCustomerAccount();
    // }
  }, []);

  useEffect(() => {
    if (availablePaymentBalance) {
      fetchGetDeliveryQrCode();
      fetchGetCustomerSingleOrder();
      fetchLocalPaymentMode();
      fetchStoreCustomerInfo();
      // if (scaccountHandleEnabled === true) {
      //   fetchStoreCustomerAccount();
      // }
    }
  }, [availablePaymentBalance]);

  useEffect(() => {
    if (qrDeviceModalPayment.status) {
      setModalVisible(true);
      setApiResStatus(qrDeviceModalPayment.status);
      setApiResMessage(qrDeviceModalPayment.message);

      fetchGetDeliveryQrCode();
      fetchGetCustomerSingleOrder();
      fetchLocalPaymentMode();
      fetchStoreCustomerInfo();
      // if (scaccountHandleEnabled === true) {
      //   fetchStoreCustomerAccount();
      // }
    }
  }, [qrDeviceModalPayment]);

  const onRefresh = useCallback(() => {
    setRefreshing(true);
    fetchGetDeliveryQrCode();
    fetchGetCustomerSingleOrder();
    fetchLocalPaymentMode();
    fetchStoreCustomerInfo();
    // if (scaccountHandleEnabled === true) {
    //   fetchStoreCustomerAccount();
    // }
    setTimeout(() => {
      setRefreshing(false);
    }, 2000);
  }, []);

  const onSelectCategoryAfterProcessOrder = (item) => {
    if (item.id === 1) {
      navigate("/OrdersGarmentInfo", {
        state: {
          bookingOrderId: bookingOrderId,
          storeCustomerId: storeCustomerId,
        },
      });
    } else if (item.id === 2) {
      navigate("/CustomerInfo", {
        state: {
          storeCustomerId: storeCustomerId,
        },
      });
    } else {
      navigate("/");
    }
  };

  const [
    isCheckedPackageSubscriptionOfferId,
    setIsCheckedPackageSubscriptionOfferId,
  ] = useState(null);
  const [
    isCheckedPackageSubscriptionOfferValue,
    setIsCheckedPackageSubscriptionOfferValue,
  ] = useState(null);
  const [
    isApplyDiscountOnlyValue,
    setIsApplyDiscountOnlyValue,
  ] = useState(null);

  const receiveDataFromPaymentDetails = ({
    paymentMethodValue,
    receiveAmountValue,
    paymentMethodSecondValue,
    receiveAmountSecondValue,
    otherRemarkValue,
    paymentError,
    paymentSecondError,
    receiveAmountError,
    receiveAmountSecondError,
    userAccountBalanceAmountError,
    discountAmount,
    addDiscount,
    paymentWalletBalanceStatus,
    paymentMethodRefundValue,
    isCheckedRefundAmountCash,
    isCheckedRefundAmountUserAccount,
    checkedPackageSubscriptionOfferId,
    checkedPackageSubscriptionOfferValue,
    qrDeviceModalPayment,
    userAccountLowBalanceError,
    isApplyDiscountOnly
  }) => {
    setPaymentMethodData(paymentMethodValue);
    setReceiveAmountValueData(receiveAmountValue);
    setPaymentMethodSecondData(paymentMethodSecondValue);
    setReceiveAmountValueSecondData(receiveAmountSecondValue);
    setOtherRemarkValueData(otherRemarkValue);
    setPaymentErrorCheck(
      paymentError ||
        receiveAmountError ||
        userAccountBalanceAmountError ||
        userAccountLowBalanceError ||
        paymentSecondError ||
        receiveAmountSecondError,
    );
    setDiscountAmountData(discountAmount);
    setAddDiscountData(addDiscount);
    setAvailablePaymentBalance(paymentWalletBalanceStatus);
    setPaymentMethodRefundData(paymentMethodRefundValue);
    setIsCheckedRefundAmountCashData(isCheckedRefundAmountCash);
    setIsCheckedRefundAmountUserAccountData(isCheckedRefundAmountUserAccount);
    setIsCheckedPackageSubscriptionOfferId(checkedPackageSubscriptionOfferId);
    setIsCheckedPackageSubscriptionOfferValue(
      checkedPackageSubscriptionOfferValue,
    );
    setQrDeviceModalPayment(qrDeviceModalPayment);
    setIsApplyDiscountOnlyValue(isApplyDiscountOnly);
  };

  useEffect(() => {
    if (isCheckedPackageSubscriptionOfferId !== null) {
      setPackageSubscriptionOfferDefault(
        brandId,
        storeId,
        isCheckedPackageSubscriptionOfferId,
      )
        .then((response) => {
          if (!response.data.error) {
            const Res = response.data;
            if (Res.status) {
              const data = {
                id: bookingOrderId,
                storeUserId: storeUserId,
                editByUserName:
                  userProfileData?.firstName + userProfileData?.lastName,
                autoApplySubscriptionWithPackage:
                  isCheckedPackageSubscriptionOfferValue > 0 ? true : false,
              };

              setOrderPackageSubscription(
                storeId,
                storeCustomerId,
                bookingOrderId,
                data,
              )
                .then((response) => {
                  if (!response.data.error) {
                    const Res = response.data;
                    if (Res.status) {
                      navigate("/SubscriptionAppliedSuccessfully", {
                        state: {
                          storeCustomerId: storeCustomerId,
                          bookingOrderId: bookingOrderId,
                        },
                      });
                    }
                  }
                })
                .catch((err) => {
                  console.error("Error:", err);
                });
            }
          }
        })
        .catch((err) => {
          console.error("Error:", err);
        });
    }
  }, [isCheckedPackageSubscriptionOfferId]);

  const handleModalMenu = () => {
    setModalMenuVisible(true);
  };

  const paymentDTO = {
    receivedBy: storeUserId,
    paidBy: storeCustomerId,
    amount: Number(
      Number(receiveAmountValueData)?.toFixed(enabledAmountRoundOff),
    ),
    paymentMode: paymentMethodData,
  };

  const otherPaymentInfoDTO = {
    amount: Number(
      Number(receiveAmountValueSecondData)?.toFixed(enabledAmountRoundOff),
    ),
    paymentMode: paymentMethodSecondData,
  };

  const discountDataCal = {
    ...addDiscountData,
    amount: discountAmountData,
  };

  const handlePaymentLink = () => {
    setIsReceivePaymentButtonPressed(true);
    setPaymentGatewayLinkCreateModalVisible(true);
  };

  const handleApplyDiscount = () => {
    if (
      isReceivePaymentButtonPressed ||
      !(discountAmountData > 0) ||
      paymentMethodData !== "" ||
      receiveAmountValueData !== ""
    ) {
      return;
    }
    setIsReceivePaymentButtonPressed(true);

    const selectedQrCodeItems = readyToDeliveryData.map((item) => item.id);

    const paymentDTOInDiscount = {
      receivedBy: storeUserId,
      paidBy: storeCustomerId,
      amount: 0,
      paymentMode: "",
    };

    const deliveryOrderData = {
      garmentList: selectedQrCodeItems,
      orderChargeDiscountDTO: discountDataCal,
      paymentDTO: paymentDTOInDiscount,
      otherPaymentInfo: otherPaymentInfoDTO,
      storeUserId: storeUserId,
      editByUserName: userProfileData?.firstName + userProfileData?.lastName,
      deliverySource: "BY_STORE",
      remarks: otherRemarkValueData,
    };

    deliveryOrder(storeCustomerId, storeId, bookingOrderId, deliveryOrderData)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setModalVisible(true);
          setApiResStatus(Res.status);
          setApiResMessage(Res.message);
          if (Res.status) {
            const timer = setTimeout(() => {
              navigate("/OrdersGarmentInfo", {
                state: {
                  bookingOrderId: bookingOrderId,
                  storeCustomerId: storeCustomerId,
                },
              });
            }, 1500);
            return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const handleConfirmAndContinue = () => {
    // Check if the button has already been pressed
    if (
      paymentMethodData === "USER_ACCOUNT" &&
      Number(
        Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(
          enabledAmountRoundOff,
        ),
      ) < receiveAmountValueData
    ) {
      setUserAccountBalanceAmountDeliveryError("Your Account Balance is Low");
      setIsReceivePaymentButtonPressed(false);
    } else {
      if (!isReceivePaymentButtonPressed) {
        // Set the state to indicate that the button has been pressed
        setIsReceivePaymentButtonPressed(true);

        const selectedQrCodeItems = readyToDeliveryData.map((item) => item.id);

        const deliveryOrderData = {
          garmentList: selectedQrCodeItems,
          orderChargeDiscountDTO: discountDataCal,
          paymentDTO: unprocessedGarmentWithSubscription ? null : paymentDTO,
          otherPaymentInfo: otherPaymentInfoDTO,
          storeUserId: storeUserId,
          editByUserName:
            userProfileData?.firstName + userProfileData?.lastName,
          deliverySource: "BY_STORE",
          remarks: otherRemarkValueData,
        };
        const subscriberOfferData = { applied: true };

        const refundData = {
          storeCustomerId: storeCustomerId,
          storeId: storeId,
          orderId: bookingOrderId,
          refundBy: storeUserId,
          amount: -orderInfoDetails.balanceAmount,
          paymentMode: paymentMethodRefundData,
          paymentRefNo: "",
        };

        if (customerOrdersData.subscriptionDiscount > 0) {
          if (customerOrdersData.appliedSubscriptionDiscount === false) {
            subscriberOffer(
              storeCustomerId,
              storeId,
              bookingOrderId,
              subscriberOfferData,
            )
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;

                  if (Res.status) {
                    deliveryOrder(
                      storeCustomerId,
                      storeId,
                      bookingOrderId,
                      deliveryOrderData,
                    )
                      .then((response) => {
                        if (!response.data.error) {
                          const Res = response.data;
                          setModalVisible(true);
                          setApiResStatus(Res.status);
                          setApiResMessage(Res.message);
                          if (Res.status) {
                            const timer = setTimeout(() => {
                              navigate("/OrdersGarmentInfo", {
                                state: {
                                  bookingOrderId: bookingOrderId,
                                  storeCustomerId: storeCustomerId,
                                },
                              });
                            }, 1500);
                            return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                          }
                        }
                      })
                      .catch((err) => {
                        console.error("Error:", err);
                      });
                  }
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          } else {
            deliveryOrder(
              storeCustomerId,
              storeId,
              bookingOrderId,
              deliveryOrderData,
            )
              .then((response) => {
                if (!response.data.error) {
                  const Res = response.data;
                  setModalVisible(true);
                  setApiResStatus(Res.status);
                  setApiResMessage(Res.message);
                  if (Res.status) {
                    const timer = setTimeout(() => {
                      navigate("/OrdersGarmentInfo", {
                        state: {
                          bookingOrderId: bookingOrderId,
                          storeCustomerId: storeCustomerId,
                        },
                      });
                    }, 1500);
                    return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                  }
                }
              })
              .catch((err) => {
                console.error("Error:", err);
              });
          }
        } else if (
          orderInfoDetails.balanceAmount < 0 &&
          (isCheckedRefundAmountCashData ||
            isCheckedRefundAmountUserAccountData)
        ) {
          deliveryOrder(
            storeCustomerId,
            storeId,
            bookingOrderId,
            deliveryOrderData,
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                if (Res.status) {
                  refundOrder(storeId, refundData)
                    .then((response) => {
                      if (!response.data.error) {
                        const Res = response.data;
                        setModalVisible(true);
                        setApiResStatus(Res.status);
                        setApiResMessage(Res.message);
                        if (Res.status) {
                          const timer = setTimeout(() => {
                            navigate("/OrdersGarmentInfo", {
                              state: {
                                bookingOrderId: bookingOrderId,
                                storeCustomerId: storeCustomerId,
                              },
                            });
                          }, 1500);
                          return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                        }
                      }
                    })
                    .catch((err) => {
                      console.error("Error:", err);
                    });
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        } else {
          deliveryOrder(
            storeCustomerId,
            storeId,
            bookingOrderId,
            deliveryOrderData,
          )
            .then((response) => {
              if (!response.data.error) {
                const Res = response.data;
                setModalVisible(true);
                setApiResStatus(Res.status);
                setApiResMessage(Res.message);
                if (Res.status) {
                  const timer = setTimeout(() => {
                    navigate("/OrdersGarmentInfo", {
                      state: {
                        bookingOrderId: bookingOrderId,
                        storeCustomerId: storeCustomerId,
                      },
                    });
                  }, 1500);
                  return () => clearTimeout(timer); // Clear the timer if the component unmounts or modalVisible changes
                }
              }
            })
            .catch((err) => {
              console.error("Error:", err);
            });
        }
      }
    }
  };

  const renderCardAfterProcessOrder = () => {
    return CardDataAfterProcessOrder?.map((item) => (
      <div className="flex-1">
        <div
          className="cursor-pointer flex flex-1 justify-content-between align-items-center mx-4"
          onClick={() => onSelectCategoryAfterProcessOrder(item)}
          style={{
            flexDirection: "row",
            marginHorizontal: 25,
            marginBottom: 10,
          }}
        >
          <div
            className="p-3"
            style={{
              backgroundColor: item.fillColor,
              borderRadius: 50,
              borderWidth: 2,
              borderColor: item.borderColor,
            }}
          >
            <img
              src={item.img}
              style={{
                width: height < 600 ? 25 : 30,
                height: height < 600 ? 25 : 30,
                alignSelf: "center",
              }}
            />
          </div>

          <div className="flex flex-1 justify-content-center align-items-center">
            <p className="text-2xl font-medium">{item.name}</p>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#fff",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left cursor-pointer"
                  onClick={() =>
                    navigate("/OrdersGarmentInfo", {
                      state: {
                        bookingOrderId: bookingOrderId,
                        storeCustomerId: storeCustomerId,
                      },
                    })
                  }
                  style={{ fontSize: "27px", cursor: "pointer", color: "#000" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className=" text-2xl font-bold capitalize">
                Payment Collection
              </p>
            </div>
          </div>

          <div
            className="flex justify-content-center align-items-center cursor-pointer"
            onClick={() => setVisible(true)}
          >
            <i
              className="pi pi-bars"
              style={{ fontSize: "27px", marginRight: 30, color: "#000" }}
            ></i>
          </div>
        </div>
      </div>

      <div>
        <div>
          <div
            className="border-none surface-0 flex-1  mx-4 py-1 mb-3"
            style={{
              borderRadius: 5,
              backgroundImage:
                "radial-gradient(circle at left top, #1752AA, #2B70D7)",
            }}
          >
            <div className="px-4">
              <div className="flex">
                <div className="flex-1 flex justify-content-start align-items-center">
                  <p className="text-white text-lg font-normal capitalize">
                    Order No. :
                  </p>
                  <p className="text-white text-xl font-semibold capitalize ml-2">
                    {orderInfoDetails.orderNo}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-1 mx-4 my-2">
            {renderCardAfterProcessOrder()}
          </div>
        </div>
        <div className="flex flex-1">
          <div className="flex-1">
            {/* Order Info start*/}
            <div
              className="flex-1  surface-0"
              style={{ "--surface-0": "#EAEFF5" }}
            >
              <div className="flex justify-content-between mx-4">
                <div className="py-1">
                  <p className=" text-2xl  font-bold ">Order Info</p>
                </div>
              </div>
            </div>
            <PaymentCollectionOrderInfoCard
              customerOrdersData={customerOrdersData}
            />
          </div>
          <div className="flex-1">
            {/* Garment Info start*/}
            <div
              className="flex-1  surface-0"
              style={{ "--surface-0": "#EAEFF5" }}
            >
              <div className="flex justify-content-between mx-4">
                <div className="py-1">
                  <p className=" text-2xl  font-bold ">Garment Info</p>
                </div>
              </div>
            </div>
            <div className="flex">
              <GarmentInfoQrCodeCard
                readyToDeliveryData={readyToDeliveryData}
              />
            </div>
            {/* Garment Info end*/}
          </div>
        </div>

        <div style={{ marginBottom: 10 }}></div>

        {!unprocessedGarmentWithSubscription && (
          <div style={{ position: "relative" }}>
            <div
              className="flex-1  surface-0"
              style={{ "--surface-0": "#EAEFF5" }}
            >
              <div className="flex justify-content-between mx-4">
                <div className="py-1">
                  <p className=" text-2xl  font-bold ">Payment Details</p>
                </div>
                <div className="flex justify-content-center align-items-center">
                  {storeData.enableDeliveryVerification &&
                    storeData.enableDeliveryVerificationByStore && (
                      <div
                        className="cursor-pointer"
                        onClick={() => {
                          setAuthCodeCustomerVerifyModalVisible(true);
                        }}
                      >
                        <img
                          src={
                            "Laundy_App_Icons_Gifs/Order_Statuses_icons/Paid_Payment_Status.png"
                          }
                        />
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>
        )}
        {!unprocessedGarmentWithSubscription && (
          <PaymentDetails
            sendDataToPaymentCollectionPage={receiveDataFromPaymentDetails}
            paymentModeData={paymentModeData}
            balanceAmount={orderInfoDetails.balanceAmount}
            userAccountBalanceAmount={Number(
              Number(storeCustomerAccountResponse.advanceUnit || 0)?.toFixed(
                enabledAmountRoundOff,
              ),
            )}
            userAccountSubscriptionUnit={
              storeCustomerAccountResponse.subscriptionUnit
            }
            storeCustomerId={storeCustomerId}
            storeId={storeId}
            deliveryDiscount={deliveryDiscount}
            enableUserAccountDeliveryDiscount={
              enableUserAccountDeliveryDiscount
            }
            setUserAccountBalanceAmountDeliveryError={
              setUserAccountBalanceAmountDeliveryError
            }
            subscriptionDiscount={customerOrdersData.subscriptionDiscount}
            storeUserId={storeUserId}
            enabledSubscriptionDiscountOnDelivery={
              enabledSubscriptionDiscountOnDelivery
            }
            appliedSubscriptionDiscount={
              customerOrdersData.appliedSubscriptionDiscount
            }
            paidAmount={customerOrdersData.paidAmount}
            storeCustomerData={storeCustomerData}
            enabledLoyaltyPointStore={enabledLoyaltyPointStore}
            enabledLoyaltyPointBrand={enabledLoyaltyPointBrand}
            bookingOrderId={bookingOrderId}
            invoiceNo={customerOrdersData.invoiceNo}
            enabledApplySubscriptionWithPackage={
              enabledApplySubscriptionWithPackage
            }
            enabledAutoApplySubscriptionWithPackage={
              enabledAutoApplySubscriptionWithPackage
            }
            orderPackageData={orderPackageData}
            enabledUPIAccount={enabledUPIAccount}
            upiAccountLink={upiAccountLink}
            upiAccountId={upiAccountId}
            upiAccountName={upiAccountName}
            enabledQRDeviceModal={enabledQRDeviceModal}
            orderSubscriptionInfo={orderSubscriptionInfo}
            orderNo={orderInfoDetails.orderNo}
            onRefreshQrPayment={onRefresh}
            enabledAmountRoundOff={enabledAmountRoundOff}
          />
        )}
        <div style={{ marginBottom: 20 }}></div>
        <SuccessModal
          setModalVisible={setModalVisible}
          modalVisible={modalVisible}
          status={apiResStatus === "success" || true ? "success" : false}
          text={apiResMessage}
        />
        <AuthCodeCustomerVerifyModal
          authCodeCustomerVerifyModalVisible={
            authCodeCustomerVerifyModalVisible
          }
          setAuthCodeCustomerVerifyModalVisible={
            setAuthCodeCustomerVerifyModalVisible
          }
          storeCustomerId={storeCustomerId}
          storeId={storeId}
          bookingOrderId={bookingOrderId}
          mobileNumber={customerOrdersData.customerMobile}
          customerName={customerOrdersData.customerName}
        />

        <PaymentGatewayLinkCreateModal
          paymentGatewayLinkCreateModalVisible={
            paymentGatewayLinkCreateModalVisible
          }
          setPaymentGatewayLinkCreateModalVisible={
            setPaymentGatewayLinkCreateModalVisible
          }
          receiveAmountValue={receiveAmountValueData}
          storeCustomerId={storeCustomerId}
          storeId={storeId}
          brandId={brandId}
          storeUserId={storeUserId}
          bookingOrderId={bookingOrderId}
        />
      </div>
      <div className="ml-4">
        {userAccountBalanceAmountDeliveryError !== "" ? (
          <p className="text-lg font-normal" style={{ color: "red" }}>
            {userAccountBalanceAmountDeliveryError}
          </p>
        ) : paymentMethodData === "USER_ACCOUNT" &&
          (Number(
            Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(
              enabledAmountRoundOff,
            ),
          ) < receiveAmountValueData ||
            Number(
              Number(storeCustomerAccountResponse.advanceUnit)?.toFixed(
                enabledAmountRoundOff,
              ),
            ) < receiveAmountValueSecondData) ? (
          <p className="text-lg font-normal" style={{ color: "red" }}>
            Your Account Balance is Low
          </p>
        ) : (
          ""
        )}
      </div>

      {loading ? (
        <div style={{ flex: 1 }}>
          <div className="text-center">
            <ProgressSpinner
              style={{ width: "70px", height: "70px" }}
              strokeWidth="4"
              fill="var(--surface-ground)"
              animationDuration="2s"
            />
          </div>
        </div>
      ) : paymentMethodData === "ONLINE" ? (
        <div
          className="flex flex-1 flex-row  py-2 sticky z-2 bottom-0 w-full"
          style={{ backgroundColor: "white" }}
        >
          <div className="flex-1 flex-row mx-4 mb-1 gap-2">
            <Button
              className="p-2 w-full text-2xl border-1 flex justify-content-center uppercase"
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
              onClick={() => handlePaymentLink()}
              disabled={isReceivePaymentButtonPressed}
            >
              RECEIVE PAYMENT
            </Button>
          </div>
        </div>
      ) : isApplyDiscountOnlyValue ? (
        <div
          className="flex flex-1 flex-row  py-2 sticky z-2 bottom-0 w-full"
          style={{ backgroundColor: "white" }}
        >
          <div className="flex-1 flex-row mx-4 mb-1 gap-2">
        <Button
         className="p-2 w-full text-2xl border-1 flex justify-content-center uppercase"
          onClick={handleApplyDiscount}
          disabled={isReceivePaymentButtonPressed}
        >
          
            Apply Discount
           
        </Button>
        </div>
        </div>
      ) : (
        <div
          className="flex flex-1 flex-row  py-2 sticky z-2 bottom-0 w-full"
          style={{ backgroundColor: "white" }}
        >
          <div className="flex-1 flex-row mx-4 mb-1 gap-2">
            <Button
              className="p-2 w-full text-2xl border-1 flex justify-content-center uppercase"
              style={{
                color: "#fff",
                backgroundColor: "#2B70D7",
                borderRadius: 5,
              }}
              onClick={() => handleConfirmAndContinue()}
              disabled={
                paymentErrorCheck
                  ? true
                  : paymentMethodData === "USER_ACCOUNT" &&
                      Number(
                        Number(
                          storeCustomerAccountResponse.advanceUnit,
                        )?.toFixed(enabledAmountRoundOff),
                      ) < receiveAmountValueData
                    ? true
                    : isReceivePaymentButtonPressed
              }
            >
              {orderInfoDetails.balanceAmount > 0 && paymentMethodData
                ? "Receive Payment & Deliver"
                : "Deliver"}
            </Button>
          </div>
        </div>
      )}
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
    </div>
  );
};

export default PaymentCollection;
